import React, { useContext } from 'react';
import {
  FormField,
  FormInputGroup,
  FormLabel,
  StandardForm,
  Dropdown,
  DropdownOption,
  GridContainer,
  Row,
  Column,
} from '@vp/swan';
import { DebugModeContext } from '../../contexts/DebugModeContext';
import { modBossLogLevels } from '../../../uxMods/modBossLogLevels';

export const ModBossLogDropdown = () => {
  const { modBossLogLevel, setModBossLogLevel } = useContext(DebugModeContext);

  const onOptionSelect = event => {
    setModBossLogLevel(event.target.value);
  };

  return (
    <StandardForm variant="horizontal">
      <GridContainer>
        <Row component={FormField}>
          <Column>
            <FormLabel>ModBoss Log Level:</FormLabel>
          </Column>
          <Column>
            <FormInputGroup>
              <Dropdown
                size="mini"
                onChange={onOptionSelect}
                value={modBossLogLevel}
                mx={3}
              >
                {modBossLogLevels.map(logLevel => (
                  <DropdownOption value={logLevel} key={logLevel}>
                    {logLevel}
                  </DropdownOption>
                ))}
              </Dropdown>
            </FormInputGroup>
          </Column>
        </Row>
      </GridContainer>
    </StandardForm>
  );
};
